import staticQueryData from "../../public/static/d/1893685880.json";
export const usePrimaryNavigationData = () => {
  var _queryData$prismicNav, _queryData$prismicNav2;

  const queryData = staticQueryData.data;
  return (_queryData$prismicNav = queryData.prismicNavigation) === null || _queryData$prismicNav === void 0 ? void 0 : (_queryData$prismicNav2 = _queryData$prismicNav.data) === null || _queryData$prismicNav2 === void 0 ? void 0 : _queryData$prismicNav2.primary;
};